import React from "react";
import { CheckIcon } from "@aureskonnect/react-ui";

type Props = {
    isActive: boolean;
};

export default function CenteredCheckCell({ isActive }: Props) {
    if (!isActive) return <span />;
    return (
        <span>
            <CheckIcon
                className="mt-1 ml-1 cmn_chk_selectButton"
                height={30}
                width={30}
            />
        </span>
    );
}
